<template>
  <Layout>
    <template #header> </template>
    <template>
      <ContentTextEdit :xmlJson="xmlJson"/>
    </template>
    <template #footer> </template>
  </Layout>
</template>

<script>
import Layout from "./DetailContentLayout.vue";
import ContentTextEdit from "./DetailContentTextEdit.vue";

import { mapState } from "vuex";

export default {
  props: {
    xmlJson: {
      type: Object,
      required: true,
    },
  },
  components: {
    Layout,
    ContentTextEdit,
  },
};
</script>
